import type { Asset } from '../../../types/asset.types';
import type { ImageAssetType } from '@/components/ui/carousel/carousel.types';

/**
 * Wire `Asset` → grid `ImageAssetType`. Extracted from usePropertyAssets'
 * mapAssets (which keeps the ordering rules) so single-asset paths — a DV-2524
 * recover response — map identically instead of maintaining a second copy.
 */
export function toImageAsset(item: Asset, photosetId?: string): ImageAssetType {
  return {
    photoUUID: item.photoUUID,
    assetUUID: item.assetUUID,
    caches: item.caches ?? undefined,
    caption: item.caption ?? undefined,
    // DV-2856: null is meaningful (not stamped yet) and must survive the map,
    // so this is `?? null`, not the `?? undefined` the nullable strings get.
    imageID: item.imageID ?? null,
    createdAt: item.createdAt ?? undefined,
    propertyUUID: item.propertyUUID,
    orderUUID: item.orderUUID,
    sortOrder: item.sortOrder,
    hidden: item.hidden,
    // DV-2252: re-hydrate the staged flag (+ room/style) from the backend so
    // the badge and "Virtually Staged" tab survive a reload. Room/style only
    // carried when actually staged.
    staged: item.staged,
    // DV-2826: distinct from `staged` — only set server-side on an asset the
    // AI-staging commit flow actually produced, never on a plain upload into
    // the Virtual Staging tab. Drives "Regenerate with AI" eligibility.
    stagedFromAssetUUID: item.stagedFromAssetUUID ?? undefined,
    ...(item.staged
      ? {
          stagedRoomType: item.roomType ?? undefined,
          stagedStyle: item.style ?? undefined
        }
      : {}),
    ...(photosetId ? { photosetUUID: photosetId } : {})
  };
}
